import { Folder, FolderCreate, FolderUpdate } from '@/types/Folder';
import { restFactory } from './apis';

export default restFactory<Folder, FolderCreate, FolderUpdate>('folders');
